<template>
  <div class="fixed bottom-0 left-0 ml-8 mb-8 rounded bg-white border-main border p-2 w-64" v-if="products.length > 0">
    <div class="relative mb-2">
      <button class="bt clear absolute top-0 right-0" type="button" @click="clearComparison()"><action-icons icon="close" class="w-4 h-4" /></button>
      <p class="text-sm pt-1">Compara productos</p>
    </div>
    <div class="flex flex-row mb-2">
      <div class="w-1/4 p-1 border" :key="`comparable-product-${i}`" v-for="(product, i) in products">
        <a :href="`/productos/${product.slug}`"><img :src="product.image" :title="product.name"></a>
      </div>
    </div>

    <div class="text-center">
      <button type="button" class="bt clear text-sm disabled" disabled v-if="products.length < 2">Comparar</button>
      <a :href="`/productos/comparar/${category}`" class="bt main text-sm" v-else>Comparar</a>
    </div>
  </div>
</template>
<script>
import { globalEventBus } from '../../_globalEventBus';
export default {
  name: 'compare-products-list',
  props: {
    category: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      products: [],
    }
  },
  methods: {
    getProducts: async function() {
      try {
        let res = await axios.get(`/productos/comparar/listado?category=${this.category}`);
        let { data } = await res.data;
        this.products = data;
      } catch(e) {
      }
    },
    updateProduct(data) {
      axios.put(
        '/productos/comparar/actualizar-producto',
        {
          product: data.product,
          selected: data.selected,
          category: this.category
        }
      )
      .then(response => {
        this.products = response.data.data;
      })
      .catch(error => {
        alert('Lo sentimos, no pudimos actualizar tus productos a comparar. Intenta nuevamente.');
      });
    },
    clearComparison() {
      axios.delete(`/productos/comparar/limpiar/${this.category}`)
      .then(response => {
        this.products = response.data.data;

        globalEventBus.$emit('clearComparison', this.category);
      })
      .catch(error => {
        alert('Lo sentimos, no pudimos actualizar tus productos a comparar. Intenta nuevamente.');
      });
    }
  },
  mounted() {
    globalEventBus.$on('productCompared', data => {
      if (this.products.length == 4 && data.selected) {
        globalEventBus.$emit('comparisonRejected', data.product);
        return false;
      }

      this.updateProduct(data);
    });

    this.getProducts();
  }
}
</script>